





























import IPerson from '@/store/models/IPerson';
import IListPhonePrefix from '@/store/models/IListPhonePrefix';
import { Vue, Component, Watch } from 'vue-property-decorator';
import PersonApi from '../store/api/PersonApi';
import UserApi from '../store/api/UserApi';
import ListPhonePrefixesApi from '../store/api/ListPhonePrefixesApi';
import PersonSelector from '@/components/selectors/Person/PersonSelector.vue';
import Snackbar from '@/components/shared/Snackbar.vue';
import ICompany from '@/store/models/ICompany';
import CompanyApi from '../store/api/CompanyApi';
import IUser from '@/store/models/IUser';
import IRole from '@/store/models/IRole';
import RoleApi from '../store/api/RoleApi';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
@Component({
    components: {
        PersonSelector,
        Snackbar
    }
})
export default class Users extends Vue {
    // PersonSelector
    PersonList : IPerson[] = [];
    personApi : PersonApi;
    userApi : UserApi;
    ListPhonePrefix : IListPhonePrefix[] = [];
    listPhonePrefixesApi : ListPhonePrefixesApi;
    phonePrefixCountry : string[] = [];
    selectedPerson : IPerson | null = null;
    idPerson : string = "";
    idCompany : string = "";
    CompanyList : ICompany[] = [];
    CompanyApi : CompanyApi;
    RoleList : IRole[] = [];
    roleApi : RoleApi;
    permissions : IRolePermission[] = [];
    overlay: boolean = false;

    constructor() {
        super();
        this.personApi = new PersonApi();
        this.listPhonePrefixesApi = new ListPhonePrefixesApi();
        this.userApi = new UserApi();
        this.CompanyApi = new CompanyApi();
        this.roleApi = new RoleApi();
    }

    created() {
        this.getPermissions();
        this.getPersons();
        this.getListPhonePrefixes();
        this.getCompanies();
        this.getRoles();
    }

    getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Users"));
    }

    async getRoles() {
        this.RoleList = await this.roleApi.GetRoles(this.idCompany);
    }

    async getPersons() {
        this.PersonList = await this.personApi.GetPersons(this.idCompany);
    }

    async getCompanies() {
        this.CompanyList = await this.CompanyApi.GetCompaniesById(this.idCompany);
    }

    async getListPhonePrefixes() {
        this.ListPhonePrefix = await this.listPhonePrefixesApi.GetListPhonePrefixes();
        if (this.ListPhonePrefix) {
            this.phonePrefixCountry = this.ListPhonePrefix.map(l => l.country);
        }
    }

    deletePerson (item: IPerson) {
        confirm('Are you sure you want to delete this user?') && this.deletePersonItem(item);
    }

    async deletePersonItem(person: IPerson) {
        this.overlay = true;
        let result: boolean = await this.personApi.DeletePerson(person.id);
        result = await this.userApi.DeleteUser(person.userName);
        if (result) {
            const index = this.PersonList.indexOf(person);
            this.PersonList.splice(index, 1);
            this.showMessageInfo(`The user ${person.name} has been successfully deleted`);
        } else {
            const errors: string = this.personApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    async savePerson (person: IPerson) {
        if (!person.id) {
            this.overlay = true;
            const user : IUser = {} as IUser;
            user.userName = person.userName;
            user.password = person.password;
            user.idRole = person.idRole;
            const idUser = await this.userApi.CreateUser(user);
            if (idUser) {
                person.idUser = idUser;
                const id = await this.personApi.SavePerson(person);
                if (id && idUser) {
                    person.id = id;
                    this.PersonList = [person].concat(this.PersonList);
                    this.selectedPerson = person;
                    this.showMessageInfo(`The user ${person.userName} has been successfully saved`);
                } else {
                    const errors: string = this.personApi.getModelError().join("; ");
                    this.showMessageError(errors);
                }
            } else {
                const errors: string = this.userApi.getModelError().join("; ");
                this.showMessageError(errors);
            }
            this.overlay = false;
        }
    }

    async editPerson (editedPerson: IPerson) {
        this.overlay = true;
        let result : boolean = await this.personApi.UpdatePerson(editedPerson);
        
        const user : IUser = {} as IUser;
        user.userName = editedPerson.userName;
        user.password = editedPerson.password;
        user.idRole = editedPerson.idRole;
        user.id = editedPerson.idUser;
        let resultUpdateUser = await this.userApi.UpdateUser(user);
        if (result && resultUpdateUser) {
            this.showMessageInfo(`The user ${editedPerson.userName} has been successfully edited`);
        } else {
            const errors: string = this.personApi.getModelError().join("; ");
            this.showMessageError(errors);
        }
        this.overlay = false;
    }

    resetPerson() {
        this.selectedPerson = null;
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
